import React, { useState } from "react";

// --- MOCK BADGE DATA (8 Badges) ---
const BADGES_DATA = [
  { title: "Fiqh Flamebearer", imgUrl: "/fiqhflame.png" },
  { title: "Shariah Sentinel", imgUrl: "/shariahsentinel.png" },
  { title: "Free Market Novice", imgUrl: "freemarketnovice.png" },
  { title: "Praxeology Practitioner", imgUrl: "praxeologypractitioner.png" },
  { title: "Scarcity Seeker", imgUrl: "scarcityseeker.png" },
  { title: "Bitcoin Believer", imgUrl: "bitcoinbeliever.png" },
  { title: "Central Bank Critic", imgUrl: "centralbankcritic.png" },
  { title: "Monetary Policy Architect", imgUrl: "monetarypolicyarchitect.png" },
  { title: "Riba Renouncer", imgUrl: "ribarenouncer.png" },
  { title: "Halal Hodler", imgUrl: "halalhodler.png" },
];
// NOTE: I used placeholder image URLs above. You should replace these with your actual image paths (e.g., /badge1.png).

/**
 * Badge component displays the badge cabinet link and a modal showing
 * all 8 badges, with a lock effect applied to unearned badges.
 * @param {number} unlockedCount - The number of badges unlocked (1-8).
 */
function Badge({ unlockedCount = 1 }) {
  const [showCabinet, setShowCabinet] = useState(false);

  // Determine the number of earned badges (must be between 1 and 8)
  const earnedCount = Math.min(16, Math.max(1, unlockedCount));

  // Inline CSS for the component
  const styles = {
    // Styles from the original .badge-link CSS
    badgeLink: {
      cursor: "pointer",
      color: "#034d28",
      fontWeight: 700,
      fontSize: "22px",
      display: "inline-block",
      margin: "10px",
      transition: "all 0.3s ease",
      position: "relative",
    },
    // Styles from the original .overlay CSS
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      backgroundColor: "rgba(0, 0, 0, 0.7)", // Slightly darker overlay
      backdropFilter: "blur(8px)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
      overflowY: "auto", // Allow scrolling on smaller screens
      padding: "20px",
    },
    // New styles for the cabinet container
    cabinetContainer: {
      backgroundColor: "white",
      borderRadius: "15px",
      padding: "30px",
      boxShadow: "0 10px 30px rgba(0, 0, 0, 0.5)",
      maxHeight: "90vh",
      overflowY: "auto",
      width: "90%",
      maxWidth: "400px",
      position: "relative",
    },
    cabinetTitle: {
      fontSize: "28px",
      fontWeight: "bold",
      textAlign: "center",
      marginBottom: "20px",
      color: "#034d28",
      borderBottom: "3px solid #034d28",
      paddingBottom: "10px",
    },
    badgeItem: {
      display: "flex",
      alignItems: "center",
      gap: "15px",
      marginBottom: "20px",
      padding: "10px",
      borderRadius: "8px",
      transition: "background-color 0.2s",
      backgroundColor: "#f9f9f9",
    },
    badgeImage: {
      width: "80px",
      height: "80px",
      borderRadius: "50%",
      objectFit: "cover",
      transition: "filter 0.5s ease-in-out",
    },
    badgeLocked: {
      filter: "grayscale(100%) blur(2px)", // Black and white + blur for locked
    },
    badgeUnlocked: {
      filter: "none",
      boxShadow: "0 0 10px rgba(3, 77, 40, 0.5)",
    },
    badgeTitle: {
      fontSize: "18px",
      fontWeight: "600",
      color: "#333",
    },
    badgeStatus: {
      fontSize: "14px",
      fontWeight: "400",
      color: "#666",
    },
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "15px",
      fontSize: "30px",
      cursor: "pointer",
      color: "#034d28",
      fontWeight: "bold",
    },
  };

  const handleLinkClick = (e) => {
    e.preventDefault();
    setShowCabinet(true);
  };

  // Stop propagation on the cabinet content to prevent the overlay from closing
  const handleCabinetClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div>
      {/* Clickable text with inline hover effects for simplicity */}
      <b 
        style={styles.badgeLink} 
        onClick={handleLinkClick}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = "#05603a"; 
          e.currentTarget.style.transform = "scale(1.05)";
          // Manually handle the ::after equivalent for underline
          e.currentTarget.style.borderBottom = "3px solid #034d28";
          e.currentTarget.style.paddingBottom = "4px";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = "#034d28"; 
          e.currentTarget.style.transform = "scale(1)";
          e.currentTarget.style.borderBottom = "none";
          e.currentTarget.style.paddingBottom = "0px";
        }}
      >
        🏅 Your Badge Cabinet
      </b>

      {/* Overlay + Badge Cabinet */}
      {showCabinet && (
        <div style={styles.overlay} onClick={() => setShowCabinet(false)}>
          <div style={styles.cabinetContainer} onClick={handleCabinetClick}>
            
            <span style={styles.closeButton} onClick={() => setShowCabinet(false)}>&times;</span>
            <div style={styles.cabinetTitle}>
              Badge Portfolio ({earnedCount}/16)
            </div>

            {BADGES_DATA.map((badge, index) => {
              // index starts at 0. Badges are unlocked if index < earnedCount.
              const isUnlocked = index < earnedCount;
              
              return (
                <div key={index} style={styles.badgeItem}>
                  {/* Badge Image with Lock/Unlock Style */}
                  <img
                    src={badge.imgUrl}
                    alt={badge.title}
                    style={{
                      ...styles.badgeImage,
                      ...(isUnlocked ? styles.badgeUnlocked : styles.badgeLocked),
                    }}
                  />

                  {/* Badge Title and Status */}
                  <div>
                    <div style={styles.badgeTitle}>
                      {badge.title}
                    </div>
                    <div style={{
                        ...styles.badgeStatus, 
                        color: isUnlocked ? "#034d28" : "#999", 
                        fontWeight: isUnlocked ? 'bold' : 'normal'
                      }}
                    >
                      {isUnlocked ? "UNLOCKED" : "LOCKED"}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default Badge;